module.exports = __webpack_public_path__ + "img/background-video-slider-chevy.c18b8ff9.jpg";